// extracted by mini-css-extract-plugin
export var container = "_5b-1";
export var cornerButtonContainer = "_5b-5";
export var disabled = "_5b-2";
export var fileContainer = "_5b-4";
export var hiddenInput = "_5b-3";
export var widthContainer = "_5b-0";